window.Bloodhound = require('typeahead.js/dist/bloodhound');
require('typeahead.js');
